export default "__VITE_ASSET__9bPbXm0p__"